(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-home"] && !Shopify.designMode) return;
  try {
    
function initLayered(root){if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('.layered-track');root.querySelectorAll('[data-layered-scroll]').forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.layeredScroll)*track.clientWidth*.8})));root.querySelectorAll('a[href^="#LayeredConcept"]').forEach(link=>link.addEventListener('click',()=>{root.querySelector('.layered-concept').open=true;}));}
document.querySelectorAll('.layered-home').forEach(initLayered);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.layered-home').forEach(initLayered));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phone-wallpaper-studio"] && !Shopify.designMode) return;
  try {
    
function initializeWallpaperStudio(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const preview=root.querySelector('[data-canvas]');
  const size=root.querySelector('[data-size]');
  const style=root.querySelector('[data-style]');
  const palettes={peach:['#e7947e','#fae7c9','#f7f4e8'],ocean:['#193e61','#6dabb6','#e0f4e9'],night:['#101524','#353456','#776687']};
  function draw(canvas,key,width,height){
    canvas.width=width;canvas.height=height;
    const context=canvas.getContext('2d');
    const gradient=context.createLinearGradient(0,0,width*.7,height);
    palettes[key].forEach((color,index)=>gradient.addColorStop(index/2,color));
    context.fillStyle=gradient;context.fillRect(0,0,width,height);
  }
  function update(){const [w,h]=size.value.split(',').map(Number);draw(preview,style.value,320,Math.round(320*h/w));}
  size.addEventListener('change',update);style.addEventListener('change',update);
  root.querySelector('[data-widgets]').addEventListener('change',event=>{root.querySelector('[data-widget-overlay]').hidden=!event.target.checked;});
  update();
  const button=root.querySelector('[data-download]');
  if(!button)return;
  const crcTable=Array.from({length:256},(_,n)=>{let c=n;for(let k=0;k<8;k++)c=(c&1)?0xedb88320^(c>>>1):c>>>1;return c>>>0;});
  function crc(bytes){let c=0xffffffff;for(const b of bytes)c=crcTable[(c^b)&255]^(c>>>8);return(c^0xffffffff)>>>0;}
  function zip(files){
    const parts=[],central=[];let offset=0,centralSize=0;
    for(const file of files){
      const name=new TextEncoder().encode(file.name),data=file.bytes,checksum=crc(data);
      const head=new Uint8Array(30+name.length),view=new DataView(head.buffer);
      view.setUint32(0,0x04034b50,true);view.setUint16(4,20,true);view.setUint16(12,0x21,true);view.setUint32(14,checksum,true);view.setUint32(18,data.length,true);view.setUint32(22,data.length,true);view.setUint16(26,name.length,true);head.set(name,30);
      const entry=new Uint8Array(46+name.length),cv=new DataView(entry.buffer);
      cv.setUint32(0,0x02014b50,true);cv.setUint16(4,20,true);cv.setUint16(6,20,true);cv.setUint16(14,0x21,true);cv.setUint32(16,checksum,true);cv.setUint32(20,data.length,true);cv.setUint32(24,data.length,true);cv.setUint16(28,name.length,true);cv.setUint32(42,offset,true);entry.set(name,46);
      parts.push(head,data);central.push(entry);offset+=head.length+data.length;centralSize+=entry.length;
    }
    const end=new Uint8Array(22),ev=new DataView(end.buffer);ev.setUint32(0,0x06054b50,true);ev.setUint16(8,files.length,true);ev.setUint16(10,files.length,true);ev.setUint32(12,centralSize,true);ev.setUint32(16,offset,true);
    return new Blob([...parts,...central,end],{type:'application/zip'});
  }
  button.addEventListener('click',async()=>{
    button.disabled=true;
    try{
      const [width,height,family]=size.value.split(','),files=[];
      for(const key of Object.keys(palettes)){
        const canvas=document.createElement('canvas');draw(canvas,key,Number(width),Number(height));
        const png=await new Promise((resolve,reject)=>canvas.toBlob(blob=>blob?resolve(blob):reject(new Error('PNG export failed')),'image/png'));
        files.push({name:`${family}/${key}-${width}x${height}.png`,bytes:new Uint8Array(await png.arrayBuffer())});
      }
      files.push({name:'READ-ME.txt',bytes:new TextEncoder().encode('The Digital Cart — Free Gradient Starter\nThree static PNG wallpapers. Personal use only; no resale or redistribution.\nInstall and automation guide: https://getlockscreens.com/pages/wallpaper-setup-guide\nPreview clocks and widgets are not baked into these images. No app or animated wallpaper is included.\n')});
      const url=URL.createObjectURL(zip(files)),anchor=document.createElement('a');anchor.href=url;anchor.download=`free-gradient-starter-${family}-${width}x${height}.zip`;document.body.append(anchor);anchor.click();anchor.remove();setTimeout(()=>URL.revokeObjectURL(url),60000);
    }catch(error){root.querySelector('[data-download-status]').textContent=root.dataset.exportError;}
    finally{button.disabled=false;}
  });
}
document.querySelectorAll('[data-wallpaper-studio]').forEach(initializeWallpaperStudio);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-wallpaper-studio]').forEach(initializeWallpaperStudio));

  } catch(e) { console.error(e); }
})();
})();
